<template>
  <Button
    v-if="showEditButton"
    color="text-primary"
    :title="$t('Edit order')"
    :icon-btn="true"
    :icon-with-background="true"
    small
    class="ma-1"
    @click="editOrder"
  >
    <v-icon
      size="small"
      color="primary"
    >
      mdi-pencil
    </v-icon>
  </Button>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import Button from "@/components/input-components/Button.vue";
import {ORDER_STATUS} from "@/utils/constants";
import {Order} from "@/entities/order";
import { usePermissionsService } from '@/composables/usePermissionsService';
import { useRouter} from 'vue-router';
import { authKey } from '@/plugins/authentication';

defineOptions({ name: "OrderGridActionEdit" });

const props = defineProps<{
  order: {
    orderId: number;
    statusId: string;
    doctorId: string;
    type: Order,
    required: true,
  }
}>()

const permissionsService = usePermissionsService()
const router = useRouter()

const auth = inject(authKey)!;
const authUserId = computed(() => auth.value?.sub);

const showEditButton = computed(() =>
  (permissionsService.hasOrderUpdatePermission &&
    props.order.statusId === ORDER_STATUS.draft &&
    props.order.doctorId === authUserId.value
  ) ||
  permissionsService.hasOrderUpdateAllPermission
)

function editOrder() {
  router.push({ path: `/order/edit/${props.order.orderId}` })
}
</script>
